export type MessageType = 'success' | 'error' | 'warning';

export const getColor = (type: MessageType) => {
    switch (type) {
        case 'error':
            return 'orange';
        case 'warning':
            return 'yellow';
        default:
            return 'green';
    }
};
